import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { massRestoreAirports } from "../../api/apiAirports";
import parseError from "../../utils/parseError";

const useRestoreAllAirports = () => {
    const queryClient = useQueryClient();

    const { mutate: restoreAllAirports, isPending } = useMutation({
        mutationFn: massRestoreAirports,
        onSuccess: (res) => {
            const message = res?.message || "Airports restored successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["airports"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to restore airports");
        },
    });

    return { restoreAllAirports, isRestoreAll: isPending };
};

export default useRestoreAllAirports;
